import { authStore } from "@/config/stores";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: App,
});

function App() {
  const navigate = useNavigate();
  const { isLoggedIn } = authStore();

  useEffect(() => {
    if (isLoggedIn) {
      navigate({ to: "/dashboard" });
      return;
    }
    navigate({ to: "/auth/login" });
  }, [isLoggedIn, navigate]);

  return null;
}
